export default "__VITE_ASSET__f4d4929f__"